module.exports = __webpack_public_path__ + "img/match-t.8a973501.png";